import { Injectable } from '@angular/core';
import { Actions, ofActionCompleted, Select, Store } from '@ngxs/store';
import { filter, map, Observable, takeUntil, tap } from 'rxjs';

import { ActivityDateData } from '@hiptraveler/data-access/api';
import { ItineraryState } from '@hiptraveler/data-access/itinerary';
import { ProfileAction } from '@hiptraveler/data-access/profile';
import { SearchPageControlStateService } from '@hiptraveler/common';
import { SearchResultDialogActionService } from '@hiptraveler/dialogs/search-result-dialog';
import { DataAccessService } from '../../../common';

@Injectable()
export class FavoritesTabService {

  @Select(ItineraryState.actDate) actDate$: Observable<ActivityDateData[] | null>;

  constructor(
    private store: Store,
    private actions$: Actions,
    public searchPageControl: SearchPageControlStateService,
    public searchResultDialog: SearchResultDialogActionService,
    private dataAccess: DataAccessService
  ) { }

  observeSelection(): void {
    this.actions$.pipe(
      ofActionCompleted(ProfileAction.ToggleProfileResultLike),  filter(event =>
        event.result.successful &&
        !event.result.error &&
        !event.result.canceled &&
        !!event.action?.data
      ),
      map(e => e.action.data),
      tap(({ id, field }) => {
        this.store.dispatch(new ProfileAction.RemoveFavoriteByType(id, field));
      }),
      takeUntil(this.dataAccess.subscription$)
    ).subscribe();
  }
  
}
